
// Related articles for the armpit health basics article
export const armpitHealthBasicsRelatedArticles = [
  {
    id: "armpit-pain-causes",
    slug: "understanding-armpit-pain",
    title: "Understanding Armpit Pain: 10 Common Causes and Effective Remedies"
  },
  {
    id: "deodorant-guide",
    slug: "the-ultimate-deodorant-guide",
    title: "The Ultimate Deodorant Guide: Finding the Perfect Product for Your Needs"
  },
  {
    id: "shaving-armpits-guide",
    slug: "how-to-shave-armpits-properly",
    title: "The Complete Guide to Shaving Your Armpits"
  }
];
